import React from 'react';
import { Phone } from 'lucide-react';
export function Header() {
  const scrollToForm = () => {
    document.getElementById('quote-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className="sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm" data-id="element-129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-130">
        {/* Logo */}
        <a href="#" className="flex items-center" aria-label="LynJones Logistics home" data-id="element-131">
          <img src="https://lynjoneslogistics.com/wp-content/uploads/lynjones-logistics-Final.png" alt="LynJones Logistics" className="h-12 md:h-14 w-auto object-contain" data-id="element-132" />
        </a>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-6" data-id="element-133">
          <a href="tel:+17543251100" className="flex items-center gap-2 text-brand-navy hover:text-brand-red transition-colors font-bold text-lg" data-id="element-134">
            <Phone className="w-5 h-5" data-id="element-135" />
            (754) 325-1100
          </a>
          <button onClick={scrollToForm} className="bg-brand-red hover:bg-brand-red-hover text-white font-bold py-2.5 px-6 rounded-lg shadow-md transition-all" data-id="element-136">
            Get a Free Quote
          </button>
        </div>

        {/* Mobile Phone Icon (CTA bar handles the rest) */}
        <div className="md:hidden flex items-center" data-id="element-137">
          <a href="tel:+17543251100" className="text-brand-navy p-2 bg-slate-100 rounded-full" aria-label="Call us" data-id="element-138">
            <Phone className="w-5 h-5" data-id="element-139" />
          </a>
        </div>
      </div>
    </header>;
}